module.exports = __webpack_public_path__ + "img/s4.528520d7.png";